var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.08,
    height: 21.806,
    viewBox: "0 0 19.08 21.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock-solid",
    d: "M6.133,6.133V8.177h6.814V6.133a3.407,3.407,0,0,0-6.814,0ZM3.407,8.177V6.133a6.133,6.133,0,0,1,12.266,0V8.177h.681A2.728,2.728,0,0,1,19.08,10.9V19.08a2.728,2.728,0,0,1-2.726,2.726H2.726A2.728,2.728,0,0,1,0,19.08V10.9A2.728,2.728,0,0,1,2.726,8.177Z",
    fill: "#fff",
    opacity: 0.998
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.abf09bf90c4e3c3db2eb65941a9ee4d7.svg";
export { ForwardRef as ReactComponent };